module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Calculator-0f5c12ac3e86fc76c4279535a37024ea.svg";